import _ from 'lodash';
import moment from 'moment';

const initialState = {
	list: null,
	availability: [],
	pimDataForList: [],
};

export default function user(state = initialState, action) {
    switch (action.type) {
	    case 'SAVE_TO_LIST':
			const data = action.data;
			const packageItem = [];
			const looseProducts = [];
			if(data && data.responseObject && data.responseObject.wishlistItems) {
				data.responseObject.wishlistItems = data.responseObject.wishlistItems.sort((a, b) => {
					if(moment(a.createdDate).isBefore(moment(b.createdDate))) {
						return -1;
					} else if(moment(b.createdDate).isBefore(moment(a.createdDate))) {
						return 1;
					} else {
						return 0
					}
				});

				data.responseObject.wishlistItems.forEach((item) => {
					if (item.packageName) {
						packageItem.push(item);
					} else {
						looseProducts.push(item);
					}
				});
				data.responseObject.wishlistItems = looseProducts.concat(packageItem);
			}
	        return { ...state,
	            list: data
	        }
		case 'SAVE_PIM_DATA_FOR_LIST':
			return { ...state,
				pimDataForList: action.data
			};
		case 'SAVE_PRODUCT_AVAILABILITY_LIST':
			let availability = [];
			if(action.data !== null && action.data !== ''){
				action && action.data && action.data.responseObject.length > 0 && action.data.responseObject.forEach((item, index) => {
					availability.push(item)
				});
			};
			availability = _.sortBy(availability, ['sku'])
			return { ...state,
				availability
			};
		case 'RESET_AVAILABILITY_TO_LIST':
			return { ...state,
				availability: []
			};
		case 'RESET_LIST_REDUCERS':
			return initialState;
	    default:
	        return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/list.js